import { Box, styled } from '@mui/material';
import { APPROVAL_SECTION_GAP } from '@/components/Approval/@components/InfoSection';

/** 레거시 마크업(class 동일)에 쓰인 유틸 class 만 보충 */
export const ResignationRoot = styled(Box)`
  & .text-center {
    text-align: center;
  }
  & .text-right {
    text-align: right;
  }
  & .d-block {
    display: block;
  }
  & .d-flex {
    display: flex;
  }
  & .justify-content-end {
    justify-content: flex-end;
  }
  & .pb-20 {
    padding-bottom: 20px;
  }
  & .mb-10 {
    margin-bottom: 10px;
  }
  & .mt-5 {
    margin-top: 5px;
  }
  & .mt-15 {
    margin-top: 15px;
  }
  & .mr-15 {
    margin-right: 15px;
  }
  & .label {
    display: block;
    margin-bottom: 6px;
    font-size: 14px;
  }
  & .alert-text {
    margin: 4px 0 0;
    color: var(--dk-danger, #f55060);
    font-size: 12px;
  }
`;

/** 조회 — 퇴사 정보·퇴직 사유·퇴직 서약서 묶음 사이 여백을 같게(레거시 pb-20·mb-10 이 묶음마다 달라 좁아 보임) */
export const ResignationViewRoot = styled(ResignationRoot)`
  & > div {
    padding-bottom: 0;
    margin-bottom: 0;
  }
  & > div + div {
    margin-top: ${APPROVAL_SECTION_GAP}px;
  }
  & > div > .pb-20 {
    padding-bottom: 0;
  }
  & #reasonDetail {
    margin-top: 20px;
  }
`;

/** 레거시 .retirement-pledge */
export const PledgeBox = styled(Box)`
  padding: 12px;
  border: 1px solid var(--dk-line-strong, #d3d3d3);
  border-radius: 6px;
  font-size: 14px;
  line-height: 22px;
  white-space: normal;

  & ol {
    margin: 15px 0 0;
    padding-left: 15px;
    list-style: decimal;
  }
  & ol li {
    margin-top: 10px;
  }
  & ol li:first-of-type {
    margin-top: 0;
  }
`;
